module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 160
// module chunks = 0